import { accountingSoftwares } from '@/libs/const.js';

export const getSoftware = (id) => ({
    id,
    name: accountingSoftwares.get(id),
});

export const initGetRequest = (dispatch) => (url) => dispatch('apiRequest', { url, method: 'get' });
